import { render, staticRenderFns } from "./clauseOrdersCustom.vue?vue&type=template&id=3ff68c1e&scoped=true"
import script from "./clauseOrdersCustom.vue?vue&type=script&lang=js"
export * from "./clauseOrdersCustom.vue?vue&type=script&lang=js"
import style0 from "./clauseOrdersCustom.vue?vue&type=style&index=0&id=3ff68c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff68c1e",
  null
  
)

export default component.exports